import React from "react";
import { Navigate } from "react-router-dom";

//Dashboard
import Dashboard from "../pages/Dashboard";

// Due Diligence Search
// //Transactions
// // NFT Marketplace Pages
// //AuthenticationInner pages

// //login
import Login from "../pages/Authentication/Login";
import ForgetPasswordPage from "../pages/Authentication/ForgetPassword";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";

//Charts
// Landing Index
// // User Profile
import DueDiligenceSearch from "../pages/DueDiligenceSearch";
import Payments from "pages/Payments";
import ReportingAgenciesReport from "../pages/Reports/ReportingAgenciesReport";
import GenderAnalysisReport from "../pages/Reports/GenderAnalysisReport";
import Users from "pages/Users";
import AgencyDashboard from "../pages/Agency/Dashboard/AgencyDashboard";
import AgencyUsers from "../pages/Agency/Users/AgencyUsers";
import Individuals from "pages/Individuals";
import MDAs from "pages/MDAs";
import ReportingAgencies from "pages/ReportingAgencies";
import ViewReportingAgency from "pages/ReportingAgencies/ViewAgency";
import PaymentCategoriesReports from "pages/Reports/PaymentCategoriesReport";
import MDAsReport from "pages/Reports/MDAsReport";
import Countries from "pages/Countries";
import Regions from "pages/Regions";
import Agencies from "pages/Agencies";
import PaymentCategories from "pages/DataTypes/PaymentCategories";
import PositionTypes from "pages/DataTypes/PositionTypes";
import ViewIndividual from "pages/Individuals/ViewIndividual";
import ViewPayment from "pages/Payments/ViewPayment";
import ViewMDA from "pages/MDAs/ViewMDA";
import GovernmentRequests from "pages/GovernmentRequests";
import AddGovernmentRequest from "pages/GovernmentRequests/AddRequest";
import AgencyIndividuals from "pages/Agency/Individuals";
import AgencyPayments from "pages/Agency/Payments";
import AgencyGovernmentRequests from "pages/Agency/GovernmentRequests";
import ThematicAnalysisReport from "pages/Reports/ThematicAnalysisReport";
import ThematicArea from "pages/DataTypes/ThematicArea";
import Sector from "pages/DataTypes/Sector";
import ViewGovtRequest from "pages/GovernmentRequests/ViewGovernmentRequest";
import UpdateGovernmentRequest from "pages/GovernmentRequests/UpdateRequest";
import MyProfile from "pages/Authentication/MyProfile";
import AgencyAddGovernmentRequest from "pages/Agency/GovernmentRequests/AddRequest";
import AgencyUpdateGovernmentRequest from "pages/Agency/GovernmentRequests/UpdateRequest";
import ResetPassword from "pages/Authentication/ResetPassword";
import AdminOverlappingPayments from "pages/OverlappingPayments";
import ViewOverlappingPayment from "pages/OverlappingPayments/ViewOverlappingPayment";
import AgencyOverlappingPayments from "pages/Agency/OverlappingPayments";
import ViewAgencyOverlappingPayment from "pages/Agency/OverlappingPayments/ViewOverlappingPayment";
import LOAs from "pages/LOA";
import AddLOA from "pages/LOA/AddLOA";
import ViewLOA from "pages/LOA/ViewLOA";
import UpdateLOA from "pages/LOA/UpdateLOA";
import GovernmentRequestForm from "pages/Public/GovernmentRequestForm";

const authProtectedRoutes = [
  //Dashboard
  { path: "/dashboard", component: <Dashboard /> },
  { path: "/index", component: <Dashboard /> },

  // Search
  { path: "/search", component: <DueDiligenceSearch /> },

  // Individuals
  { path: "/individuals", component: <Individuals /> },
  { path: "/individuals/:id", component: <ViewIndividual /> },
  // Payments
  { path: "/payments", component: <Payments /> },
  { path: "/payments/:id", component: <ViewPayment /> },
  // MDAs
  { path: "/mdas", component: <MDAs /> },
  { path: "/mdas/:id", component: <ViewMDA /> },
  // Reporting Agencies
  { path: "/reporting-agencies", component: <ReportingAgencies /> },
  { path: "/reporting-agencies/:id", component: <ViewReportingAgency /> },
  // Government Requests
  { path: "/government-requests", component: <GovernmentRequests /> },
  { path: "/government-requests/:id", component: <ViewGovtRequest /> },
  { path: "/government-requests/add", component: <AddGovernmentRequest /> },
  {
    path: "/government-requests/update/:id",
    component: <UpdateGovernmentRequest />,
  },
  { path: "/loas", component: <LOAs /> },
  { path: "/loas/add", component: <AddLOA /> },
  { path: "/loas/:id", component: <ViewLOA /> },
  { path: "/loas/update/:id", component: <UpdateLOA /> },
  // Reports
  {
    path: "/reports/payment-categories-report",
    component: <PaymentCategoriesReports />,
  },
  {
    path: "/reports/reporting-agencies-report",
    component: <ReportingAgenciesReport />,
  },
  { path: "/reports/mdas-report", component: <MDAsReport /> },
  {
    path: "/reports/gender-analysis-report",
    component: <GenderAnalysisReport />,
  },
  {
    path: "/reports/thematic-analysis-report",
    component: <ThematicAnalysisReport />,
  },

  { path: "/users", component: <Users /> },
  { path: "/agency/agency-dashboard/agency", component: <AgencyDashboard /> },

  { path: "/agency-data/individuals", component: <AgencyIndividuals /> },
  { path: "/agency-data/payments", component: <AgencyPayments /> },
  {
    path: "/agency/government-requests",
    component: <AgencyGovernmentRequests />,
  },
  {
    path: "/agency/government-requests/add",
    component: <AgencyAddGovernmentRequest />,
  },
  {
    path: "/agency/government-requests/update/:id",
    component: <AgencyUpdateGovernmentRequest />,
  },
  { path: "/agency/users", component: <AgencyUsers /> },

  { path: "/countries", component: <Countries /> },
  { path: "/regions", component: <Regions /> },

  { path: "/agencies", component: <Agencies /> },

  {
    path: "/overlapping-payments",
    component: <AdminOverlappingPayments />,
  },
  {
    path: "/overlapping-payments/:id",
    component: <ViewOverlappingPayment />,
  },
  {
    path: "/agency/overlapping-payments",
    component: <AgencyOverlappingPayments />,
  },
  {
    path: "/agency/overlapping-payments/:id",
    component: <ViewAgencyOverlappingPayment />,
  },

  { path: "/data-types/payment-categories", component: <PaymentCategories /> },
  { path: "/data-types/position-types", component: <PositionTypes /> },
  { path: "/data-types/thematic-areas", component: <ThematicArea /> },
  { path: "/data-types/sectors", component: <Sector /> },
  //User Profile
  { path: "/profile", component: <MyProfile /> }, // Room B 1st floor

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
  { path: "*", component: <Navigate to="/dashboard" /> },
];

const publicRoutes = [
  // Authentication Page
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPasswordPage /> },
  { path: "/signup", component: <Register /> },
  { path: "/reset-password", component: <ResetPassword /> },
  { path: "/government-request-form", component: <GovernmentRequestForm /> },
];

export { authProtectedRoutes, publicRoutes };
